
import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Reporting from "../pages/Reporting";
import Dashboard from "../pages/Dashboard";
import Unbind from "../pages/Unbind";
import OnboardMerchantPage from "../pages/OnboardMerchantPage";
import CreateTerminalPage from "../pages/CreateTerminalPage";
import Merchants from "../pages/merchants";
import Terminals from "../pages/terminals";
import Users from "../pages/users";
import CreateUser from "../pages/CreateUsers";
import Operations from "../pages/Operations";
import Inventory from "../pages/Inventory";
import HardPOS from "../pages/HardPOS";

function DashboardLayout() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode") || "create";

  return (
    <div className="dashboard-layout">
      {/* Sidebar always visible */}
      <Sidebar />

      <div className="dashboard-main">
        {/* Navbar - Now handles its own title dynamically */}
        <Navbar />

        {/* Swappable content */}
        <div className="dashboard-content">
          {location.pathname.includes("reporting") ? (
            <Reporting isSidebarOpen={true} />
          ) : location.pathname.includes("unbind") ? (
            <Unbind isSidebarOpen={true} />
          ) : location.pathname.includes("merchantslist") ? (
            <Merchants isSidebarOpen={true} />
          ) : location.pathname.includes("merchant") ? (
            <OnboardMerchantPage isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("terminalslist") ? (
            <Terminals isSidebarOpen={true} />
          ) : location.pathname.includes("terminal") ? (
            <CreateTerminalPage isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("userslist") ? (
            <Users isSidebarOpen={true} />
          ) : location.pathname.includes("hardpos") ? (
            <HardPOS isSidebarOpen={true} />
          ) : location.pathname.includes("inventory") ? (
            <Inventory isSidebarOpen={true} />
          ) : location.pathname.includes("user") ? (
            <CreateUser isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("operations") ? (
            <Operations isSidebarOpen={true} />
          ) : (
            <Dashboard isSidebarOpen={true} />
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
